module.exports = __webpack_public_path__ + "img/success.afb4ba41.png";